import S from "./index.module.scss";
import { Marker, Tooltip } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import L from "leaflet";
import { useAddressesData } from "@/views/addresses/hooks/useAddressesData";
import { observer } from "mobx-react-lite";
import { useStore } from "@/hooks/system/useStore";

const AddressesCluster = () => {
  const { query, map } = useStore("addresses");
  const { addresses } = useAddressesData(query);

  const customIcon = L.icon({
    iconUrl: "/icons/map-location-icon.svg",
    iconSize: [40, 40],
    iconAnchor: [20, 40],
  });

  return (
    <MarkerClusterGroup maxClusterRadius={25} disableClusteringAtZoom={6}>
      {addresses?.map((addr, idx: number) => (
        <Marker
          key={idx}
          position={[Number(addr.lat), Number(addr.lon)]}
          icon={customIcon}
          eventHandlers={{
            click: () => {
              map?.flyTo([Number(addr.lat), Number(addr.lon)], 14);
            },
          }}
        >
          <Tooltip>
            <div className={S.tooltip}>
              <img src="/icons/location-icon-black.svg" alt="location" />
              <span>{addr.title}</span>
            </div>
          </Tooltip>
        </Marker>
      ))}
    </MarkerClusterGroup>
  );
};

export default observer(AddressesCluster);
